import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app/module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app/ducks';
import { ProgressCircular } from '@americanexpress/dls-react';
import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';

import RepositoryAndDocTypeSelector from './RepositoryAndDocTypeSelector';

const AxpDocRepositories = (props) => {
  const {
    languageData,
    locale,
    repositoryView,
    onResponseReset,
    submitResponse,
    icaasMarket,
    icaasFlowType,
    handleDocTypeRes,
    scrollIntoSelect,
    guid,
    repoConfigId,
  } = props;

  const inboundURL = useSelector((state) => state.getIn(['config', 'imageViewerDocUploadApiUrl']));
  const activeLocale = useSelector((state) => state.getIn(['intl', 'activeLocale']));

  if (Object.entries(languageData).length === 0) {
    return <ProgressCircular />;
  }
  const onSelectionChange = () => {};

  return (
    <main>
      <IntlProvider
        locale={locale || activeLocale || 'en-US'}
        defaultLocale="en-US"
        messages={languageData}
      >
        <RepositoryAndDocTypeSelector
          repositoryView={repositoryView}
          onResponseReset={onResponseReset}
          submitResponse={submitResponse}
          icaasMarket={icaasMarket}
          icaasFlowType={icaasFlowType}
          handleDocTypeRes={handleDocTypeRes}
          scrollIntoSelect={scrollIntoSelect}
          guid={guid}
          repoConfigId={repoConfigId}
          inboundURL={inboundURL}
          onSelectionChange={onSelectionChange}
        />
      </IntlProvider>
    </main>
  );
};

export const TestableAxpDocRepositories = AxpDocRepositories;

export function mapStateToProps(state, ownProps) {
  const guid = ownProps.guid || '';
  const icaasMarket = ownProps.icaasMarket || '';
  const repoConfigId = ownProps.repoConfigId || '';
  const icaasFlowType = ownProps.icaasFlowType || '';
  return {
    guid,
    icaasMarket,
    repoConfigId,
    icaasFlowType,
  };
}

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(loadLanguagePack('axp-document-repositories', { fallbackLocale: 'en-US' }));
};

AxpDocRepositories.holocron = {
  name: 'axp-document-repositories',
  loadModuleData,
};

export default compose(
  oneAppModuleWrapper('axp-document-repositories'),
  connect(mapStateToProps)
)(AxpDocRepositories);
